// Full-document render of the loadup (mattress pickup request) confirmation
// page: PageSkeleton wrapping the account-page layout with the static
// thank-you copy.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoadupRequestConfirmationDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <div className="account-page-title">
                    <h2>{t`Mattress Pickup Request`}</h2>
                </div>

                <div className="account-form">
                    <p>
                        {t`Thank you for submitting a Mattress Pickup Request Form!`}
                    </p>
                    <p>
                        {t`Please allow 1-3 business days for our pickup partners to email you for scheduling.`}
                    </p>
                </div>
            </div>
        </PageSkeleton>
    );
};
